import React from 'react'
import { View } from 'react-native'

import { FlashList } from '@shopify/flash-list'
import { YStack } from '@zet/design-system/layout'

import { useApiAction } from '../../api/useApiAction'
import { state } from '../../utils/types'
import Field from './field'
import SectionTitle from './sectionTitle'

const HDFC_PARTNER_ID = 299

type Field = {
  label: string
  value?: string | boolean | number
}
interface Props {
  title: string
  state: state
  disabled?: boolean
  fields: Field[]
}

const SectionCard: React.FC<Props> = (props) => {
  const { title, state, fields, disabled = false } = props
  const { data } = useApiAction({ skipInitFetch: true })

  const renderFields = ({ item }: { item: Field }) => {
    if (!item?.value && data?.metadata?.partnerId === HDFC_PARTNER_ID) {
      return null
    }
    return <Field {...item} />
  }

  const ItemSeparatorComponent = (item: { trailingItem: Field }) => {
    if (
      !item?.trailingItem?.value &&
      data?.metadata?.partnerId === HDFC_PARTNER_ID
    ) {
      return null
    }
    return <View className="my-2" />
  }

  return (
    <YStack className="bg-grays-10 p-4">
      <SectionTitle title={title} state={state} disabled={disabled} />
      <FlashList
        data={fields}
        renderItem={renderFields}
        ItemSeparatorComponent={ItemSeparatorComponent}
      />
    </YStack>
  )
}

export default SectionCard
